import { render, staticRenderFns } from "./create-moovly.vue?vue&type=template&id=a27c2066&"
import script from "./create-moovly.vue?vue&type=script&lang=js&"
export * from "./create-moovly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports